// src/componants/manager/TeamManagement.js
import React, { useState } from "react";
import { useData } from "../../context/DataContext";
import EmployeeHistoryView from "../common/EmployeeHistoryView";
import "./TeamManagement.css";
import "../common/EmployeeHistoryView.css";

function TeamManagement({ userRole = "manager" }) {
  const { teamMembers } = useData();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [historyEmployee, setHistoryEmployee] = useState(null);
  const [historyTab, setHistoryTab] = useState(null);

  const canManage = userRole === "hr" || userRole === "hr-staff" || userRole === "gm";

  const filteredTeam = teamMembers.filter(
    (member) =>
      member.name?.includes(searchTerm) ||
      member.code?.includes(searchTerm) ||
      member.jobTitle?.includes(searchTerm),
  );

  const activeCount = teamMembers.filter((m) => m.status === "active").length;
  const onLeaveCount = teamMembers.filter(
    (m) => m.status === "on-leave",
  ).length;

  function handleAddClick() {
    alert(
      "إضافة أعضاء الفريق تتم من خلال HR → إدارة الأعضاء",
    );
  }

  function openDeleteModal(member) {
    setSelectedMember(member);
    setShowDeleteModal(true);
  }

  function confirmDelete() {
    alert("إنهاء خدمة الموظف يتم عبر HR من API");
    setShowDeleteModal(false);
    setSelectedMember(null);
  }

  function getStatusBadge(status) {
    if (status === "active")
      return <span className="team-status active">نشط</span>;
    if (status === "on-leave")
      return <span className="team-status on-leave">في إجازة</span>;
    return <span className="team-status inactive">غير نشط</span>;
  }

  if (historyEmployee) {
    return (
      <EmployeeHistoryView
        employee={historyEmployee}
        userRole={userRole}
        initialTab={historyTab || undefined}
        onBack={() => {
          setHistoryEmployee(null);
          setHistoryTab(null);
        }}
      />
    );
  }

  return (
    <div className="team-management" dir="rtl">
      <div className="team-header">
        <div>
          <h2 className="team-title">إدارة الفريق</h2>
          <p className="team-subtitle">
            {teamMembers.length} عضو | {activeCount} نشط | {onLeaveCount} في
            إجازة
          </p>
        </div>
        {canManage && (
          <button type="button" className="team-add-btn" onClick={handleAddClick}>
            + إضافة عضو
          </button>
        )}
      </div>

      <input
        type="text"
        className="team-search-input"
        placeholder="بحث بالاسم أو الكود..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="team-table-wrapper">
        <table className="team-table">
          <thead>
            <tr>
              <th>الاسم</th>
              <th>الكود</th>
              <th>المسمى</th>
              <th>تاريخ الانضمام</th>
              <th>الحالة</th>
              <th>إجراءات</th>
            </tr>
          </thead>
          <tbody>
            {filteredTeam.map((member) => (
              <tr key={member.id}>
                <td data-label="الاسم">{member.name}</td>
                <td data-label="الكود">{member.code}</td>
                <td data-label="المسمى">{member.jobTitle}</td>
                <td data-label="تاريخ الانضمام">{member.joinDate}</td>
                <td data-label="الحالة">{getStatusBadge(member.status)}</td>
                <td data-label="إجراءات">
                  <button
                    type="button"
                    className="team-action-btn history"
                    onClick={() => {
                      setHistoryTab(null);
                      setHistoryEmployee(member);
                    }}
                  >
                    السجل
                  </button>
                  <button
                    type="button"
                    className="team-action-btn history"
                    onClick={() => {
                      setHistoryTab("agenda");
                      setHistoryEmployee(member);
                    }}
                  >
                    الأجندة
                  </button>
                  {canManage && (
                    <button
                      type="button"
                      className="team-action-btn delete"
                      onClick={() => openDeleteModal(member)}
                    >
                      حذف
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredTeam.length === 0 && (
          <p className="team-empty">لا يوجد أعضاء في الفريق</p>
        )}
      </div>

      {showDeleteModal && selectedMember && (
        <div
          className="team-modal-overlay"
          onClick={() => setShowDeleteModal(false)}
        >
          <div className="team-modal" onClick={(e) => e.stopPropagation()}>
            <h3>تأكيد الحذف</h3>
            <p>هل تريد إنهاء خدمة {selectedMember.name}؟</p>
            <div className="team-modal-actions">
              <button type="button" onClick={() => setShowDeleteModal(false)}>
                إلغاء
              </button>
              <button type="button" className="danger" onClick={confirmDelete}>
                تأكيد
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeamManagement;
